export default function initializeHomeSlider() {
  const sliders = document.querySelectorAll('.home-slider:not(.home-slider--disabled)');
  if (sliders.length === 0) return;
  return import('swiper/bundle').then(({default: Swiper}) => {
    sliders.forEach(function (slider) {

      // dodajemy efekt parallax ( data-swiper-parallax) do każdego elementu treści slajdu
      slider.querySelectorAll('.home-slider__content-inner > .wp-block-group ').forEach(function (coverContent) {
        var i = 300;
        coverContent.querySelectorAll(':scope > *').forEach(function (element) {
          element.setAttribute('data-swiper-parallax', i);
          element.setAttribute('data-swiper-parallax-duration', 2.5*i);
          i += 100;
        });
      });


      const swiper = new Swiper(slider, {
        speed: 1500,
        loop: true,
        parallax: true,
        effect: "fade",
        autoplay: {
          delay: 3500,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: slider.querySelector('.home-slider__arrow--next') ?? null,
          prevEl: slider.querySelector('.home-slider__arrow--prev') ?? null,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
        },
        // on: {
        //   slideChangeTransitionStart: function () {
        //     // Dodajemy klasę zoom-in do aktualnego obrazka
        //     const activeSlide = slider.querySelector('.swiper-slide-active');
        //     if (activeSlide) {
        //       const img = activeSlide.querySelector('.home-slider__img');
        //       if (img) {
        //         console.log('zoom-in add');
        //         img.classList.add('zoom-in');
        //       }
        //     }
        //
        //   },
        //   slideChangeTransitionEnd: function () {
        //     slider.querySelectorAll('.home-slider__img').forEach(function (img) {
        //       if(img.closest('.swiper-slide-active')) return;
        //       img.classList.remove('zoom-in');
        //       console.log('zoom-in remove');
        //     });
        //   }
        // }

      });
    });
  });
}